<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <div class="d-flex" :class="{ 'flex-column': isMobile }">
        <div style="flex-basis: 70%">
          <SoRow>
            <SoCol>
              <MeterReadingsWidget />
            </SoCol>
            <SoCol>
              <LastMeterReadWidget />
            </SoCol>
          </SoRow>
          <SoRow>
            <SoCol>
              <h5 class="mb-2">Meterpoints</h5>
              <MeterpointsWidget />
            </SoCol>
          </SoRow>
        </div>
        <div
          :class="{ 'mt-4': isMobile, 'ml-4': !isMobile }"
          style="flex-basis: 30%"
        >
          <MeterpointsInfoBoxes />
        </div>
      </div>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoContainer from "@/components/SoContainer.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import MeterpointsWidget from "./widgets/MeterpointsWidget.vue"
  import MeterReadingsWidget from "./widgets/MeterReadingsWidget.vue"
  import MeterpointsInfoBoxes from "./components/MeterpointsInfoBoxes.vue"
  import LastMeterReadWidget from "./widgets/LastMeterReadWidget.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"

  export default defineComponent({
    components: {
      MeterpointsWidget,
      MeterReadingsWidget,
      MeterpointsInfoBoxes,
      LastMeterReadWidget,
      SoContainer,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile
      },
    },
  })
</script>
